import { useState } from 'react';
import SignIn from './SignIn';
import SignUp from './SignUp';
import Logo from '../common/Logo';
import './AuthCard.css';

const AuthCard = () => {
  const [isSignIn, setIsSignIn] = useState(true);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <Logo className="auth-logo" />
          <h1>{isSignIn ? 'Welcome Back' : 'Create Account'}</h1>
          <p className="auth-subtitle">
            {isSignIn 
              ? 'Enter your credentials to access your account' 
              : 'Start your journey with us today'}
          </p>
        </div>
        
        {isSignIn ? <SignIn /> : <SignUp />}
        
        <div className="auth-footer">
          <p>
            {isSignIn ? "Don't have an account? " : "Already have an account? "}
            <button 
              className="auth-switch-btn"
              onClick={() => setIsSignIn(!isSignIn)}
            >
              {isSignIn ? 'Sign Up' : 'Sign In'}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthCard; 